/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VersionRouteImport } from './routes/version'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PoliciesIndexRouteImport } from './routes/policies/index'
import { Route as NhiOlcmIndexRouteImport } from './routes/nhi-olcm/index'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index'
import { Route as IdentitiesIndexRouteImport } from './routes/identities/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.index'
import { Route as AgentIndexRouteImport } from './routes/agent.index'
import { Route as AgentRuntimeAuthzIndexRouteImport } from './routes/agent-runtime-authz.index'
import { Route as AgentGatewayIndexRouteImport } from './routes/agent-gateway.index'
import { Route as PoliciesSplatRouteImport } from './routes/policies/$'
import { Route as NhiOlcmSplatRouteImport } from './routes/nhi-olcm/$'
import { Route as IntegrationsSplatRouteImport } from './routes/integrations/$'
import { Route as IdentitiesSplatRouteImport } from './routes/identities/$'
import { Route as DashboardSplatRouteImport } from './routes/dashboard.$'
import { Route as AgentSplatRouteImport } from './routes/agent.$'
import { Route as AgentRuntimeAuthzSplatRouteImport } from './routes/agent-runtime-authz.$'
import { Route as AgentGatewaySplatRouteImport } from './routes/agent-gateway.$'
import { Route as IntegrationsUniversalOnboardingIndexRouteImport } from './routes/integrations/universalOnboarding.index'
import { Route as AdminSavRoleManagementIndexRouteImport } from './routes/admin/sav-role-management/index'
import { Route as AdminOverviewIndexRouteImport } from './routes/admin/overview/index'
import { Route as AdminMfaIndexRouteImport } from './routes/admin/mfa/index'
import { Route as AdminIspmUsersIndexRouteImport } from './routes/admin/ispm-users/index'
import { Route as IntegrationsUniversalOnboardingSplatRouteImport } from './routes/integrations/universalOnboarding.$'
import { Route as AdminSettingsSsoSettingsIndexRouteImport } from './routes/admin/settings/sso-settings/index'
import { Route as AdminSettingsSsoSettingsEditRouteImport } from './routes/admin/settings/sso-settings/edit'
import { Route as AdminSettingsSsoSettingsCreateRouteImport } from './routes/admin/settings/sso-settings/create'

const VersionRoute = VersionRouteImport.update({
  id: '/version',
  path: '/version',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesIndexRoute = PoliciesIndexRouteImport.update({
  id: '/policies/',
  path: '/policies/',
  getParentRoute: () => rootRouteImport,
} as any)
const NhiOlcmIndexRoute = NhiOlcmIndexRouteImport.update({
  id: '/nhi-olcm/',
  path: '/nhi-olcm/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/integrations/',
  path: '/integrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const IdentitiesIndexRoute = IdentitiesIndexRouteImport.update({
  id: '/identities/',
  path: '/identities/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentIndexRoute = AgentIndexRouteImport.update({
  id: '/agent/',
  path: '/agent/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentRuntimeAuthzIndexRoute = AgentRuntimeAuthzIndexRouteImport.update({
  id: '/agent-runtime-authz/',
  path: '/agent-runtime-authz/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentGatewayIndexRoute = AgentGatewayIndexRouteImport.update({
  id: '/agent-gateway/',
  path: '/agent-gateway/',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesSplatRoute = PoliciesSplatRouteImport.update({
  id: '/policies/$',
  path: '/policies/$',
  getParentRoute: () => rootRouteImport,
} as any)
const NhiOlcmSplatRoute = NhiOlcmSplatRouteImport.update({
  id: '/nhi-olcm/$',
  path: '/nhi-olcm/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsSplatRoute = IntegrationsSplatRouteImport.update({
  id: '/integrations/$',
  path: '/integrations/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IdentitiesSplatRoute = IdentitiesSplatRouteImport.update({
  id: '/identities/$',
  path: '/identities/$',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSplatRoute = DashboardSplatRouteImport.update({
  id: '/dashboard/$',
  path: '/dashboard/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentSplatRoute = AgentSplatRouteImport.update({
  id: '/agent/$',
  path: '/agent/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentRuntimeAuthzSplatRoute = AgentRuntimeAuthzSplatRouteImport.update({
  id: '/agent-runtime-authz/$',
  path: '/agent-runtime-authz/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentGatewaySplatRoute = AgentGatewaySplatRouteImport.update({
  id: '/agent-gateway/$',
  path: '/agent-gateway/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsUniversalOnboardingIndexRoute =
  IntegrationsUniversalOnboardingIndexRouteImport.update({
    id: '/integrations/universalOnboarding/',
    path: '/integrations/universalOnboarding/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminSavRoleManagementIndexRoute =
  AdminSavRoleManagementIndexRouteImport.update({
    id: '/admin/sav-role-management/',
    path: '/admin/sav-role-management/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminOverviewIndexRoute = AdminOverviewIndexRouteImport.update({
  id: '/admin/overview/',
  path: '/admin/overview/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMfaIndexRoute = AdminMfaIndexRouteImport.update({
  id: '/admin/mfa/',
  path: '/admin/mfa/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIspmUsersIndexRoute = AdminIspmUsersIndexRouteImport.update({
  id: '/admin/ispm-users/',
  path: '/admin/ispm-users/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsUniversalOnboardingSplatRoute =
  IntegrationsUniversalOnboardingSplatRouteImport.update({
    id: '/integrations/universalOnboarding/$',
    path: '/integrations/universalOnboarding/$',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminSettingsSsoSettingsIndexRoute =
  AdminSettingsSsoSettingsIndexRouteImport.update({
    id: '/admin/settings/sso-settings/',
    path: '/admin/settings/sso-settings/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminSettingsSsoSettingsEditRoute =
  AdminSettingsSsoSettingsEditRouteImport.update({
    id: '/admin/settings/sso-settings/edit',
    path: '/admin/settings/sso-settings/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminSettingsSsoSettingsCreateRoute =
  AdminSettingsSsoSettingsCreateRouteImport.update({
    id: '/admin/settings/sso-settings/create',
    path: '/admin/settings/sso-settings/create',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/version': typeof VersionRoute
  '/agent-gateway/$': typeof AgentGatewaySplatRoute
  '/agent-runtime-authz/$': typeof AgentRuntimeAuthzSplatRoute
  '/agent/$': typeof AgentSplatRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/identities/$': typeof IdentitiesSplatRoute
  '/integrations/$': typeof IntegrationsSplatRoute
  '/nhi-olcm/$': typeof NhiOlcmSplatRoute
  '/policies/$': typeof PoliciesSplatRoute
  '/agent-gateway/': typeof AgentGatewayIndexRoute
  '/agent-runtime-authz/': typeof AgentRuntimeAuthzIndexRoute
  '/agent/': typeof AgentIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/identities/': typeof IdentitiesIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/nhi-olcm/': typeof NhiOlcmIndexRoute
  '/policies/': typeof PoliciesIndexRoute
  '/integrations/universalOnboarding/$': typeof IntegrationsUniversalOnboardingSplatRoute
  '/admin/ispm-users/': typeof AdminIspmUsersIndexRoute
  '/admin/mfa/': typeof AdminMfaIndexRoute
  '/admin/overview/': typeof AdminOverviewIndexRoute
  '/admin/sav-role-management/': typeof AdminSavRoleManagementIndexRoute
  '/integrations/universalOnboarding/': typeof IntegrationsUniversalOnboardingIndexRoute
  '/admin/settings/sso-settings/create': typeof AdminSettingsSsoSettingsCreateRoute
  '/admin/settings/sso-settings/edit': typeof AdminSettingsSsoSettingsEditRoute
  '/admin/settings/sso-settings/': typeof AdminSettingsSsoSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/version': typeof VersionRoute
  '/agent-gateway/$': typeof AgentGatewaySplatRoute
  '/agent-runtime-authz/$': typeof AgentRuntimeAuthzSplatRoute
  '/agent/$': typeof AgentSplatRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/identities/$': typeof IdentitiesSplatRoute
  '/integrations/$': typeof IntegrationsSplatRoute
  '/nhi-olcm/$': typeof NhiOlcmSplatRoute
  '/policies/$': typeof PoliciesSplatRoute
  '/agent-gateway': typeof AgentGatewayIndexRoute
  '/agent-runtime-authz': typeof AgentRuntimeAuthzIndexRoute
  '/agent': typeof AgentIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/identities': typeof IdentitiesIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/nhi-olcm': typeof NhiOlcmIndexRoute
  '/policies': typeof PoliciesIndexRoute
  '/integrations/universalOnboarding/$': typeof IntegrationsUniversalOnboardingSplatRoute
  '/admin/ispm-users': typeof AdminIspmUsersIndexRoute
  '/admin/mfa': typeof AdminMfaIndexRoute
  '/admin/overview': typeof AdminOverviewIndexRoute
  '/admin/sav-role-management': typeof AdminSavRoleManagementIndexRoute
  '/integrations/universalOnboarding': typeof IntegrationsUniversalOnboardingIndexRoute
  '/admin/settings/sso-settings/create': typeof AdminSettingsSsoSettingsCreateRoute
  '/admin/settings/sso-settings/edit': typeof AdminSettingsSsoSettingsEditRoute
  '/admin/settings/sso-settings': typeof AdminSettingsSsoSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/version': typeof VersionRoute
  '/agent-gateway/$': typeof AgentGatewaySplatRoute
  '/agent-runtime-authz/$': typeof AgentRuntimeAuthzSplatRoute
  '/agent/$': typeof AgentSplatRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/identities/$': typeof IdentitiesSplatRoute
  '/integrations/$': typeof IntegrationsSplatRoute
  '/nhi-olcm/$': typeof NhiOlcmSplatRoute
  '/policies/$': typeof PoliciesSplatRoute
  '/agent-gateway/': typeof AgentGatewayIndexRoute
  '/agent-runtime-authz/': typeof AgentRuntimeAuthzIndexRoute
  '/agent/': typeof AgentIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/identities/': typeof IdentitiesIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/nhi-olcm/': typeof NhiOlcmIndexRoute
  '/policies/': typeof PoliciesIndexRoute
  '/integrations/universalOnboarding/$': typeof IntegrationsUniversalOnboardingSplatRoute
  '/admin/ispm-users/': typeof AdminIspmUsersIndexRoute
  '/admin/mfa/': typeof AdminMfaIndexRoute
  '/admin/overview/': typeof AdminOverviewIndexRoute
  '/admin/sav-role-management/': typeof AdminSavRoleManagementIndexRoute
  '/integrations/universalOnboarding/': typeof IntegrationsUniversalOnboardingIndexRoute
  '/admin/settings/sso-settings/create': typeof AdminSettingsSsoSettingsCreateRoute
  '/admin/settings/sso-settings/edit': typeof AdminSettingsSsoSettingsEditRoute
  '/admin/settings/sso-settings/': typeof AdminSettingsSsoSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/version'
    | '/agent-gateway/$'
    | '/agent-runtime-authz/$'
    | '/agent/$'
    | '/dashboard/$'
    | '/identities/$'
    | '/integrations/$'
    | '/nhi-olcm/$'
    | '/policies/$'
    | '/agent-gateway/'
    | '/agent-runtime-authz/'
    | '/agent/'
    | '/dashboard/'
    | '/identities/'
    | '/integrations/'
    | '/nhi-olcm/'
    | '/policies/'
    | '/integrations/universalOnboarding/$'
    | '/admin/ispm-users/'
    | '/admin/mfa/'
    | '/admin/overview/'
    | '/admin/sav-role-management/'
    | '/integrations/universalOnboarding/'
    | '/admin/settings/sso-settings/create'
    | '/admin/settings/sso-settings/edit'
    | '/admin/settings/sso-settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/version'
    | '/agent-gateway/$'
    | '/agent-runtime-authz/$'
    | '/agent/$'
    | '/dashboard/$'
    | '/identities/$'
    | '/integrations/$'
    | '/nhi-olcm/$'
    | '/policies/$'
    | '/agent-gateway'
    | '/agent-runtime-authz'
    | '/agent'
    | '/dashboard'
    | '/identities'
    | '/integrations'
    | '/nhi-olcm'
    | '/policies'
    | '/integrations/universalOnboarding/$'
    | '/admin/ispm-users'
    | '/admin/mfa'
    | '/admin/overview'
    | '/admin/sav-role-management'
    | '/integrations/universalOnboarding'
    | '/admin/settings/sso-settings/create'
    | '/admin/settings/sso-settings/edit'
    | '/admin/settings/sso-settings'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/version'
    | '/agent-gateway/$'
    | '/agent-runtime-authz/$'
    | '/agent/$'
    | '/dashboard/$'
    | '/identities/$'
    | '/integrations/$'
    | '/nhi-olcm/$'
    | '/policies/$'
    | '/agent-gateway/'
    | '/agent-runtime-authz/'
    | '/agent/'
    | '/dashboard/'
    | '/identities/'
    | '/integrations/'
    | '/nhi-olcm/'
    | '/policies/'
    | '/integrations/universalOnboarding/$'
    | '/admin/ispm-users/'
    | '/admin/mfa/'
    | '/admin/overview/'
    | '/admin/sav-role-management/'
    | '/integrations/universalOnboarding/'
    | '/admin/settings/sso-settings/create'
    | '/admin/settings/sso-settings/edit'
    | '/admin/settings/sso-settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  VersionRoute: typeof VersionRoute
  AgentGatewaySplatRoute: typeof AgentGatewaySplatRoute
  AgentRuntimeAuthzSplatRoute: typeof AgentRuntimeAuthzSplatRoute
  AgentSplatRoute: typeof AgentSplatRoute
  DashboardSplatRoute: typeof DashboardSplatRoute
  IdentitiesSplatRoute: typeof IdentitiesSplatRoute
  IntegrationsSplatRoute: typeof IntegrationsSplatRoute
  NhiOlcmSplatRoute: typeof NhiOlcmSplatRoute
  PoliciesSplatRoute: typeof PoliciesSplatRoute
  AgentGatewayIndexRoute: typeof AgentGatewayIndexRoute
  AgentRuntimeAuthzIndexRoute: typeof AgentRuntimeAuthzIndexRoute
  AgentIndexRoute: typeof AgentIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  IdentitiesIndexRoute: typeof IdentitiesIndexRoute
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute
  NhiOlcmIndexRoute: typeof NhiOlcmIndexRoute
  PoliciesIndexRoute: typeof PoliciesIndexRoute
  IntegrationsUniversalOnboardingSplatRoute: typeof IntegrationsUniversalOnboardingSplatRoute
  AdminIspmUsersIndexRoute: typeof AdminIspmUsersIndexRoute
  AdminMfaIndexRoute: typeof AdminMfaIndexRoute
  AdminOverviewIndexRoute: typeof AdminOverviewIndexRoute
  AdminSavRoleManagementIndexRoute: typeof AdminSavRoleManagementIndexRoute
  IntegrationsUniversalOnboardingIndexRoute: typeof IntegrationsUniversalOnboardingIndexRoute
  AdminSettingsSsoSettingsCreateRoute: typeof AdminSettingsSsoSettingsCreateRoute
  AdminSettingsSsoSettingsEditRoute: typeof AdminSettingsSsoSettingsEditRoute
  AdminSettingsSsoSettingsIndexRoute: typeof AdminSettingsSsoSettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/version': {
      id: '/version'
      path: '/version'
      fullPath: '/version'
      preLoaderRoute: typeof VersionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies/': {
      id: '/policies/'
      path: '/policies'
      fullPath: '/policies/'
      preLoaderRoute: typeof PoliciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nhi-olcm/': {
      id: '/nhi-olcm/'
      path: '/nhi-olcm'
      fullPath: '/nhi-olcm/'
      preLoaderRoute: typeof NhiOlcmIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/': {
      id: '/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof IntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identities/': {
      id: '/identities/'
      path: '/identities'
      fullPath: '/identities/'
      preLoaderRoute: typeof IdentitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/': {
      id: '/agent/'
      path: '/agent'
      fullPath: '/agent/'
      preLoaderRoute: typeof AgentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-runtime-authz/': {
      id: '/agent-runtime-authz/'
      path: '/agent-runtime-authz'
      fullPath: '/agent-runtime-authz/'
      preLoaderRoute: typeof AgentRuntimeAuthzIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-gateway/': {
      id: '/agent-gateway/'
      path: '/agent-gateway'
      fullPath: '/agent-gateway/'
      preLoaderRoute: typeof AgentGatewayIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies/$': {
      id: '/policies/$'
      path: '/policies/$'
      fullPath: '/policies/$'
      preLoaderRoute: typeof PoliciesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nhi-olcm/$': {
      id: '/nhi-olcm/$'
      path: '/nhi-olcm/$'
      fullPath: '/nhi-olcm/$'
      preLoaderRoute: typeof NhiOlcmSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/$': {
      id: '/integrations/$'
      path: '/integrations/$'
      fullPath: '/integrations/$'
      preLoaderRoute: typeof IntegrationsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identities/$': {
      id: '/identities/$'
      path: '/identities/$'
      fullPath: '/identities/$'
      preLoaderRoute: typeof IdentitiesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/$': {
      id: '/dashboard/$'
      path: '/dashboard/$'
      fullPath: '/dashboard/$'
      preLoaderRoute: typeof DashboardSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/$': {
      id: '/agent/$'
      path: '/agent/$'
      fullPath: '/agent/$'
      preLoaderRoute: typeof AgentSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-runtime-authz/$': {
      id: '/agent-runtime-authz/$'
      path: '/agent-runtime-authz/$'
      fullPath: '/agent-runtime-authz/$'
      preLoaderRoute: typeof AgentRuntimeAuthzSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-gateway/$': {
      id: '/agent-gateway/$'
      path: '/agent-gateway/$'
      fullPath: '/agent-gateway/$'
      preLoaderRoute: typeof AgentGatewaySplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/universalOnboarding/': {
      id: '/integrations/universalOnboarding/'
      path: '/integrations/universalOnboarding'
      fullPath: '/integrations/universalOnboarding/'
      preLoaderRoute: typeof IntegrationsUniversalOnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sav-role-management/': {
      id: '/admin/sav-role-management/'
      path: '/admin/sav-role-management'
      fullPath: '/admin/sav-role-management/'
      preLoaderRoute: typeof AdminSavRoleManagementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/overview/': {
      id: '/admin/overview/'
      path: '/admin/overview'
      fullPath: '/admin/overview/'
      preLoaderRoute: typeof AdminOverviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/mfa/': {
      id: '/admin/mfa/'
      path: '/admin/mfa'
      fullPath: '/admin/mfa/'
      preLoaderRoute: typeof AdminMfaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ispm-users/': {
      id: '/admin/ispm-users/'
      path: '/admin/ispm-users'
      fullPath: '/admin/ispm-users/'
      preLoaderRoute: typeof AdminIspmUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/universalOnboarding/$': {
      id: '/integrations/universalOnboarding/$'
      path: '/integrations/universalOnboarding/$'
      fullPath: '/integrations/universalOnboarding/$'
      preLoaderRoute: typeof IntegrationsUniversalOnboardingSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings/sso-settings/': {
      id: '/admin/settings/sso-settings/'
      path: '/admin/settings/sso-settings'
      fullPath: '/admin/settings/sso-settings/'
      preLoaderRoute: typeof AdminSettingsSsoSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings/sso-settings/edit': {
      id: '/admin/settings/sso-settings/edit'
      path: '/admin/settings/sso-settings/edit'
      fullPath: '/admin/settings/sso-settings/edit'
      preLoaderRoute: typeof AdminSettingsSsoSettingsEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings/sso-settings/create': {
      id: '/admin/settings/sso-settings/create'
      path: '/admin/settings/sso-settings/create'
      fullPath: '/admin/settings/sso-settings/create'
      preLoaderRoute: typeof AdminSettingsSsoSettingsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  VersionRoute: VersionRoute,
  AgentGatewaySplatRoute: AgentGatewaySplatRoute,
  AgentRuntimeAuthzSplatRoute: AgentRuntimeAuthzSplatRoute,
  AgentSplatRoute: AgentSplatRoute,
  DashboardSplatRoute: DashboardSplatRoute,
  IdentitiesSplatRoute: IdentitiesSplatRoute,
  IntegrationsSplatRoute: IntegrationsSplatRoute,
  NhiOlcmSplatRoute: NhiOlcmSplatRoute,
  PoliciesSplatRoute: PoliciesSplatRoute,
  AgentGatewayIndexRoute: AgentGatewayIndexRoute,
  AgentRuntimeAuthzIndexRoute: AgentRuntimeAuthzIndexRoute,
  AgentIndexRoute: AgentIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  IdentitiesIndexRoute: IdentitiesIndexRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
  NhiOlcmIndexRoute: NhiOlcmIndexRoute,
  PoliciesIndexRoute: PoliciesIndexRoute,
  IntegrationsUniversalOnboardingSplatRoute:
    IntegrationsUniversalOnboardingSplatRoute,
  AdminIspmUsersIndexRoute: AdminIspmUsersIndexRoute,
  AdminMfaIndexRoute: AdminMfaIndexRoute,
  AdminOverviewIndexRoute: AdminOverviewIndexRoute,
  AdminSavRoleManagementIndexRoute: AdminSavRoleManagementIndexRoute,
  IntegrationsUniversalOnboardingIndexRoute:
    IntegrationsUniversalOnboardingIndexRoute,
  AdminSettingsSsoSettingsCreateRoute: AdminSettingsSsoSettingsCreateRoute,
  AdminSettingsSsoSettingsEditRoute: AdminSettingsSsoSettingsEditRoute,
  AdminSettingsSsoSettingsIndexRoute: AdminSettingsSsoSettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
